<section class="calculation-model-view-section-area">
  <div style="display:flex">
    <calculation-model-search-area *ngIf="searchActive" (search)="search($event)" style="width:15%"></calculation-model-search-area>
    <kendo-grid id="kendoGridCalculationModel" [kendoGridBinding]="gridView"
                kendoGridSelectBy="id"
                [selectable]="selectableSettings"
                (selectionChange)="onSelect($event)"
                [(selectedKeys)]="selectedIds"
                [pageSize]="20"
                [pageable]="true"
                [scrollable]="'scrollable'"
                style="width:100%">
      <kendo-grid-column field="id" title="ID" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="name" title="{{'calculationModel.name' |  translate | uppercase}}" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="country" [title]="'calculationModel.country' | translate | uppercase" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="status" [title]="'calculationModel.status' | translate | uppercase" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="sector" [title]="'calculationModel.sector' | translate | uppercase" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="valuationMethod" [title]="'calculationModel.valuationMethod' | translate | uppercase" [width]="220">
      </kendo-grid-column>
      <kendo-grid-column field="mappingVersion" [title]="'calculationModel.mappingVersion' | translate | uppercase" [width]="220">
      </kendo-grid-column>
    </kendo-grid>
  </div>
</section>
